<template>
  <div>
    <v-dialog v-model="value" persistent height="45%">
      <v-card>
        <div class="custom_container">
          <p class="custom_title">Este es tu código QR de ingreso y salida, descárgalo o toma captura.</p>
          <p class="custom_description">Si añadiste un correo electrónico en tu registro, revisa tu bandeja de entrada,
            te
            envíamos tu código QR.</p>
          <img :src="`data:image/png;base64,${value}`" alt="image qr">
          <div class="custom_btn-box">
            <a href="QR.png" download="" :href="`data:image/png;base64,${value}`">
              <button class="button-pale">Descargar QR</button>
            </a>
            <a href="https://www.google.com">
              <button class="button-primary">Terminar registro</button>
            </a>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['value',],
  data: () => ({
    value: false,
  })
}
</script>

<style scoped>
/* override global css tag (local) */
p {
  margin: 0;
}

img {
  margin: 10px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  width: 200px;
  height: 200px;
}

button {
  border: none;
  background: none;
  border-radius: 6px;
  padding: 8px;
}

/* override global css (class local) */
::v-deep .v-dialog {
  border-radius: 8px !important;
}

::v-deep .v-card {
  height: 100%;
}

/* csutom css */
.custom_container {
  height: 100%;
  padding: 15px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.custom_title {
  font-weight: 500;
  font-size: 15px;
  line-height: 24px;
  text-align: center;
  color: #111827;
}

.custom_description {
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: #6B7280;
  margin-bottom: 10px;
}

.custom_btn-box {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 12px;
  margin-top: 20px;
}

.button-pale {
  border: 1px solid #D1D5DB;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  color: #374151;
}

.button-primary {
  background-color: #EF565B;
  color: white;
}
</style>
